<template>
  <nav :aria-label="$t('Breadcrumb')" :class="['breadcrumb', invert ? 'invert' : '']">
    <ol itemscope itemtype="https://schema.org/BreadcrumbList">
      <li v-for="(item, i) in filteredItems" :key="item.url_key ? item.url_key : item.path" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <router-link v-if="item.url_key" :to="`${localizedUrl}/products/` + getPath(item.url_key)" itemprop="item"><span itemprop="name">{{ item.name }}</span></router-link>
        <router-link v-if="item.path" :to="`${localizedUrl}${item.path}`" itemprop="item"><span itemprop="name">{{ item.name }}</span></router-link>
        <meta itemprop="position" :content="i + 1" />
      </li>
      <li v-if="lastItem && !this.short" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <span aria-current="page" itemprop="name">{{ lastItem.name }}</span>
        <meta itemprop="position" :content="filteredItems.length + 1" />
      </li>
    </ol>
  </nav>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  props: ['items', 'pagePosition', 'siblings-components', 'short', 'invert'],
  name: 'Breadcrumb',
  computed: {
    mappedItems() {
      return this.items && this.items.length ? this.items.map((item) => {
        item.name = item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase()
        return item
       }) : []
    },
    filteredItems() {
      return this.mappedItems.filter((x, i) => i !== this.mappedItems.length - 1 && x.include_in_menu !== 0 && !(this.short && i > 1))
    },
    lastItem() {
      return this.mappedItems[this.mappedItems.length - 1]
    },
    localizedUrl() {
      const { url } = currentStoreView()
      return url || ''
    },
  },
  methods: {
    getPath(url_key) {
      return this.mappedItems.filter((x) => x.url_key === 'straps').length && url_key !== 'straps' ? 'straps-' + url_key : url_key
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.breadcrumb {
  position: absolute;
  z-index: 5;
  top: 2.5rem;
  left: 4rem;
  max-width: 45%;

  @include bp(max lg) {
    max-width: 100%;
    left: 2rem;
    top: 2rem;
  }
  @include bp(max md) {
    top: 2rem;
  }

  ol {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    li {

      &:not(:first-child):before {
        font-size: em(14);
        content: '•';
        margin: 0 1rem;
        position: relative;
        top: 0.1rem;
        color: var(--zenith-theme-primary);
      }

      a {
        font-size: em(11);
        line-height: em(15, 11);
        color: var(--zenith-theme-primary);

        &:hover,
        &:active,
        &:focus {
          opacity: 0.6;
        }
      }

      & > span {
        font-size: em(11);
        line-height: em(15, 10);
        color: var(--zenith-theme-primary);
      }
    }
  }
  &.invert {
    filter: invert(1);
  }
}
</style>
